/* eslint-disable camelcase */
import axios from 'axios';
import type { Site } from '@hotjar/site';
import type { SiteMetadataResponse } from './dto';
import type { SiteMetadata } from './model';

export const getSiteMetadata = async (site: Site): Promise<SiteMetadata> => {
  const response = await axios.get<SiteMetadataResponse>(
    `/api/v1/accounts/${site.account.id}/sites/${site.id}/metadata`,
  );

  if (!response.data.success) throw new Error('Failed fetching Site metadata.');

  const { cms, gtm, persistent_anonymous_id, ...metadata } = response.data.values;
  return {
    cms,
    gtm,
    persistentAnonymousId: persistent_anonymous_id,
    gtmInstalled: metadata.gtm_installed_in_app,
    finished: !!gtm,
  };
};
